import { getQueryKeys } from "../../helper";

const namespace = "beneficiaries";

export default {
  ...getQueryKeys(namespace),
};
